export const makePlaceholdersForBackend = (
  html: string,
  placeholders: Record<string, string>,
) => {
  Object.keys(placeholders).forEach((pKey) => {
    html = html.split(`{${placeholders[pKey]}}`).join(`{${pKey}}`);
  });
  return html;
};
